var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasksMenuItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.045,
    height: 17.045,
    viewBox: "0 0 17.045 17.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98438",
    "data-name": "Group 98438",
    transform: "translate(-0.164 -0.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27042",
    "data-name": "Group 27042",
    transform: "translate(0.209 0.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62839",
    "data-name": "Path 62839",
    d: "M13.494,0H3.551A3.555,3.555,0,0,0,0,3.551v9.943a3.555,3.555,0,0,0,3.551,3.551h8.271a3.4,3.4,0,0,0,2.42-1l1.8-1.8a3.444,3.444,0,0,0,1-2.42V3.551A3.555,3.555,0,0,0,13.494,0ZM1.42,13.494V3.551A2.133,2.133,0,0,1,3.551,1.42h9.943a2.133,2.133,0,0,1,2.131,2.131v7.1H12.784a2.133,2.133,0,0,0-2.131,2.131v2.841h-7.1A2.133,2.133,0,0,1,1.42,13.494m11.817,1.545a1.984,1.984,0,0,1-1.164.57V12.784a.711.711,0,0,1,.71-.71h2.824a2.016,2.016,0,0,1-.57,1.164l-1.8,1.8ZM3.551,4.616A1.065,1.065,0,1,1,4.616,5.682,1.066,1.066,0,0,1,3.551,4.616M5.682,8.522A1.065,1.065,0,1,1,4.616,7.457,1.066,1.066,0,0,1,5.682,8.522m0,3.906a1.065,1.065,0,1,1-1.065-1.065,1.066,1.066,0,0,1,1.065,1.065",
    transform: "translate(-0.045 -0.045)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksMenuItem);
export default __webpack_public_path__ + "static/media/tasks-menu-item.3b6daae3d8b0ebf864e5d30b1f553d4d.svg";
export { ForwardRef as ReactComponent };